<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('stockClose.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockClose.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-3">
            <ts-button color="info" outline @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-4 d-flex justify-content-end"></div>
          <div class="col-sm-12 col-md-5 d-flex justify-content-end">
            <a-month-picker
              placeholder="Select month"
              style="width:600px"
              v-model="cycle_month"
              class="mr-2"
              format="MMM-YYYY"
              valueFormat="M-YYYY"
              @change="fetchData"
              :allowClear="false"
            />
            <select
              class="form-control mr-2"
              style="width: 120px"
              v-model="status_id"
              @change="fetchData"
            >
              <option :value="null">
                {{ $t('All') }}
              </option>
              <option
                v-for="(s, index) in status"
                :key="index"
                :value="s.value"
              >
                {{ s.label }}
              </option>
            </select>
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              v-tooltip="$t('stockClose.search')"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'branch.branch_name_en'
          }"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.location ? record.location.location_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ record.cycle_month }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ record.cycle_year }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              <span
                class="badge badge-danger"
                v-if="record.status == 'CLOSED'"
                >{{ record.status }}</span
              >
              <span class="badge badge-success" v-else>{{
                record.status
              }}</span>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.created_by
                  ? record.created_by.employee
                    ? record.created_by.employee.employee_name_en
                    : ''
                  : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ record.created_date }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.modified_by
                  ? record.modified_by.employee
                    ? record.modified_by.employee.employee_name_en
                    : ''
                  : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ record.modified_date }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a
                v-if="record.status == 'CLOSED'"
                href="#"
                v-tooltip="$t('stockClose.reOpen')"
                class="mr-2 ml-2 text-success"
                @click.prevent="open(record)"
              >
                <i class="fas fa-lock-open"></i>
              </a>
              <a
                v-else
                href="#"
                v-tooltip="$t('stockClose.closeStock')"
                class="text-danger"
                @click.prevent="close(record)"
              >
                <i class="fas fa-lock"></i>
              </a>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto detail">
              <thead>
                <tr>
                  <th>{{ $t('stockClose.remarks') }}</th>
                  <th class="text-center">{{ $t('stockClose.status') }}</th>
                  <th>{{ $t('stockClose.createdBy') }}</th>
                  <th class="text-center">
                    {{ $t('stockClose.createdDate') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(detail, index) in prop.record.details" :key="index">
                  <td class="ts-p-1">
                    {{ detail.remarks }}
                  </td>
                  <td class="ts-p-1 text-center">{{ detail.status }}</td>
                  <td class="ts-p-1">
                    {{
                      detail.created_by
                        ? detail.created_by.employee
                          ? detail.created_by.employee.employee_name_en
                          : ''
                        : ''
                    }}
                  </td>
                  <td class="ts-p-1 text-center">{{ detail.created_date }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('stockClose.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'
import RemarksComponent from './remark.vue'

export default {
  name: 'stockCloseList',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false,
      status: [
        {
          value: 'CLOSED',
          label: 'CLOSED'
        },
        {
          value: 'RE-OPEN',
          label: 'RE-OPEN'
        }
      ]
    }
  },
  computed: {
    ...mapState('stock/stockClose', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.stock.stockClose.search
      },
      set (newValue) {
        this.$store.commit('stock/stockClose/SET_SEARCH', newValue)
        this.$store.commit('stock/stockClose/RESET_CURRENT_PAGE')
      }
    },
    status_id: {
      get () {
        return this.$store.state.stock.stockClose.status_id
      },
      set (newValue) {
        this.$store.commit('stock/stockClose/SET_STATUS_ID', newValue)
      }
    },
    cycle_month: {
      get () {
        return this.$store.state.stock.stockClose.cycle_month
      },
      set (newValue) {
        this.$store.commit('stock/stockClose/SET_MONTH', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('stockClose.warehouse') },
        { name: this.$t('stockClose.cycleMonth'), style: 'text-align:center;' },
        { name: this.$t('stockClose.cycleYear'), style: 'text-align:center;' },
        { name: this.$t('stockClose.status'), style: 'text-align:center;' },
        { name: this.$t('stockClose.createdBy') },
        {
          name: this.$t('stockClose.createdDate'),
          style: 'text-align:center;'
        },
        { name: this.$t('stockClose.modifiedBy') },
        {
          name: this.$t('stockClose.modifiedDate'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:2%'
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    addNew () {
      this.showForm = true
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/stockClose/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    close (record) {
      this.$store.commit('stock/stockClose/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit () {
      this.$store.commit('stock/stockClose/SET_EDIT_DATA', {})
      this.fetchData()
      this.showForm = false
    },
    open (reocrd) {
      this.$modal.show(
        RemarksComponent,
        {
          reocrd: reocrd
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stock/stockClose/RESET_STATE')
    next()
  }
}
</script>
<style scoped>
.detail td,
th {
  padding: 0.3rem;
}
</style>
